import { render } from "./transport.vue?vue&type=template&id=33114754&scoped=true"
import script from "./transport.vue?vue&type=script&lang=js"
export * from "./transport.vue?vue&type=script&lang=js"

import "./transport.vue?vue&type=style&index=0&id=33114754&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33114754"]])

export default __exports__